import { axiosInstanceMain } from "../../../utils/axiosGlobalUtils";
import { hash } from "../../../utils/hashFunction";
import { ITenant } from "../../AbmLocalPage/types";

export const getLocalInfo = async (
  id: number,
  token: string,
  tenant: ITenant
) =>
  axiosInstanceMain.post(`/${tenant.path}/locales/${id}?vendedor`, {
    clave: "8842a618d3902314c703a354076db8b0",
    token: token,
  });

export const getMetricas = async (
  idLocal: number,
  tenant: ITenant,
  detallado?: boolean
) => {
  let url = `${tenant.path}/metricas/local/${idLocal}`;

  if (detallado !== undefined) url += `?detallado=${detallado}`;

  return await axiosInstanceMain.get(url);
};

export const confirmarTenantLocal = async (
  idLocal: number,
  token: string,
  tenant: ITenant
) => {
  return await axiosInstanceMain.get(
    `${tenant.path}/locales/${idLocal}/pertenece-al-tenant`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
